import React, { useState } from "react";
import { ClockCircleOutlined, HeartOutlined, SafetyOutlined } from "@ant-design/icons";
import OnlineIndicator from "../../Preview/PreviewComponents/OnlineIndicator";
import PreviewModal from "../../Preview/PreviewComponents/PreviewModal";
import { content } from "./content";

import amcLogo from "./assets/amc-logo.png";
import heroArt from "./assets/hero-art.png";
import heroLeaves from "./assets/hero-leaves.png";
import ksApsLogo from "./assets/ks-aps-logo.png";
// The app's own KAPsurvey logo with a darker "survey", which the app's grey fades into the
// campaign's light background.
import kapSurveyLogo from "./assets/kapsurvey-logo.svg";

const FACT_ICONS = {
   time: ClockCircleOutlined,
   anonymous: SafetyOutlined,
   voluntary: HeartOutlined
};

// Replaces PreviewBanner for this survey. The campaign header is fixed content, so it does not
// read the survey's banner settings.
const TetoriRozeHero = () => {
   const [isOnlineHelpOpen, setIsOnlineHelpOpen] = useState(false);
   const { hero, onlineHelp } = content;

   return (
      <>
         <header className="tr-hero">
            <img className="tr-hero__leaves" src={heroLeaves} alt="" aria-hidden="true" />
            <img className="tr-hero__art" src={heroArt} alt="" aria-hidden="true" />

            <div className="tr-hero__status">
               <OnlineIndicator
                  indicatorClickHandler={() => setIsOnlineHelpOpen(true)}
                  color="#35131b"
               />
            </div>

            <div className="tr-hero__content">
               <div className="tr-hero__logos">
                  <span className="tr-hero__powered">
                     <span className="tr-hero__powered-label">{hero.logos.poweredBy}</span>
                     <img
                        className="tr-hero__logo"
                        src={kapSurveyLogo}
                        alt={hero.logos.kapSurvey}
                     />
                  </span>
                  <span className="tr-hero__logo-divider" aria-hidden="true" />
                  <img className="tr-hero__logo" src={ksApsLogo} alt={hero.logos.ksAps} />
                  <span className="tr-hero__logo-divider" aria-hidden="true" />
                  <img className="tr-hero__logo" src={amcLogo} alt={hero.logos.amc} />
               </div>
               <h1 className="tr-hero__title">
                  {hero.titleLead} <span>{hero.titleAccent}</span>
               </h1>
               <p className="tr-hero__subtitle">{hero.subtitle}</p>
               <p className="tr-hero__description">{hero.description}</p>
               <ul className="tr-hero__facts">
                  {hero.facts.map(({ key, label }) => {
                     const Icon = FACT_ICONS[key];

                     return (
                        <li key={key}>
                           {Icon && <Icon aria-hidden="true" />}
                           <span>{label}</span>
                        </li>
                     );
                  })}
               </ul>
            </div>
         </header>

         <PreviewModal
            title={onlineHelp.title}
            isModalOpen={isOnlineHelpOpen}
            setIsModalOpen={setIsOnlineHelpOpen}
            footer={null}
         >
            {onlineHelp.paragraphs.map((paragraph, index) => (
               <p key={index} className="tr-online-help">
                  {paragraph}
               </p>
            ))}
         </PreviewModal>
      </>
   );
};

export default React.memo(TetoriRozeHero);
